// extracted by mini-css-extract-plugin
export default {"root":"IconEmailAttention_root__egszx","marketplaceStroke":"IconEmailAttention_marketplaceStroke__F0eV-","attentionStroke":"IconEmailAttention_attentionStroke__TFEmW"};